import { render, staticRenderFns } from "./DetailsTRX.vue?vue&type=template&id=51a09e98&scoped=true&"
import script from "./DetailsTRX.vue?vue&type=script&lang=js&"
export * from "./DetailsTRX.vue?vue&type=script&lang=js&"
import style0 from "./DetailsTRX.vue?vue&type=style&index=0&id=51a09e98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a09e98",
  null
  
)

export default component.exports